<div class="inbox-container">
  <div class="panel-overview" aria-hidden="true">
    <div class="panel-overview__icon">
      <i nz-icon nzType="inbox"></i>
    </div>
    <div class="panel-overview__content">
      <div class="panel-overview__eyebrow">{{ 'activity.inbox.eyebrow' | translate }}</div>
      <div class="panel-overview__headline">
        <span class="panel-overview__count">{{ store.filteredItems().length }}</span>
        <span class="panel-overview__label">{{ 'activity.inbox.open_items' | translate }}</span>
      </div>
      <p class="panel-overview__hint">{{ 'activity.inbox.hint' | translate }}</p>
    </div>
  </div>

  <div class="private-composer">
    <div class="private-composer__intro">
      <div class="private-composer__badge">
        <i nz-icon nzType="lock"></i>
      </div>
      <div class="private-composer__copy">
        <div class="private-composer__title">{{ 'activity.inbox.private_quick_add' | translate }}</div>
        <p class="private-composer__hint">{{ 'activity.inbox.private_quick_add_hint' | translate }}</p>
      </div>
    </div>

    <nz-input-group [nzAddOnAfter]="quickAddAction" nzSize="large">
      <input
        #quickAddInput
        nz-input
        [(ngModel)]="newPrivateTaskTitle"
        placeholder="{{ 'activity.inbox.quick_add_placeholder' | translate }}"
        aria-label="{{ 'activity.inbox.quick_add_placeholder' | translate }}"
        (keydown.enter)="createPrivateTask()"
      />
    </nz-input-group>

    <ng-template #quickAddAction>
      <button class="desktop-button"
        nz-button
        nzType="primary"
        type="button"
        [disabled]="!newPrivateTaskTitle.trim() || store.isCreating()"
        (click)="createPrivateTask()"
      >
        <i *ngIf="!store.isCreating()" nz-icon nzType="plus"></i>
        <i *ngIf="store.isCreating()" nz-icon nzType="loading"></i>
        {{ 'activity.inbox.add' | translate }}
      </button>
    </ng-template>
  </div>

  <app-status-message
    *ngIf="store.error()"
    class="panel-alert"
    tone="warning"
    density="compact"
    [message]="store.error() || ''"
  ></app-status-message>

  <!-- Loading state -->
  <div *ngIf="store.isLoading()" class="loading-container">
    <app-inbox-task-skeleton [count]="4"></app-inbox-task-skeleton>
  </div>

  <!-- Empty state -->
  <div *ngIf="!store.isLoading() && store.isEmpty()" class="empty-container">
    <nz-empty
      [nzNotFoundContent]="'activity.inbox.empty' | translate"
      nzNotFoundImage="simple">
      <p nz-typography>{{ 'activity.inbox.empty_hint' | translate }}</p>
    </nz-empty>
  </div>

  <!-- Items list (all active items: assigned + own, TODO + IN_PROGRESS) -->
  <div *ngIf="!store.isLoading() && !store.isEmpty()" class="items-list">
    <app-inbox-item
      *ngFor="let item of store.filteredItems(); trackBy: trackByTaskId"
      [item]="item"
      (navigate)="onNavigate($event)"
      (markDone)="store.markTaskDone($event)"
      (assignToMe)="store.assignToMe($event)"
      (remove)="store.removeTask($event)">
    </app-inbox-item>
  </div>
</div>
